import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import AnalysisResult from './components/AnalysisResult';
import GitHubCallback from './components/GitHubCallback';
import CompareIndex from './components/CompareIndex';
import ComparisonPage from './components/ComparisonPage';
import BestTools from './components/BestTools';
import AiCodingTools from './components/AiCodingTools';
import LearnIndex from './components/LearnIndex';
import LearnArticle from './components/LearnArticle';

function App() {
  return (
    <HelmetProvider>
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/analyze" element={<AnalysisResult />} />
            <Route path="/best-ai-code-analysis-tools" element={<BestTools />} />
            <Route path="/ai-coding-tools" element={<AiCodingTools />} />
            <Route path="/compare" element={<CompareIndex />} />
            <Route path="/compare/:slug" element={<ComparisonPage />} />
            <Route path="/auth/callback" element={<GitHubCallback />} />
            <Route path="/learn" element={<LearnIndex />} />
            <Route path="/learn/:slug" element={<LearnArticle />} />
          </Routes>
        </main>
        <Footer />
        <SpeedInsights />
        <Analytics />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
